<template>
 <span class="rect" :style="`background: ${answerStyleConfig.font.quColor}`">
 </span>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AnswerRect',
  props: [],
  data () {
    return {

    }
  },
  components: {

  },
  watch: {
  },
  computed: {
    ...mapState({
      answerStyleConfig: ({ Question }) => Question.answerStyleConfig
    })
  },
  methods: {

  },
  created () {

  },
  mounted () {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/answer/AnswerRect.vue